import { Injectable } from '@angular/core';
import { GqlServiceV2 } from '../../content/service/gql.service-v2';
import { GridInput } from '@it2go/data-grid';
import { filterFrag } from '../../../services/types/filter.types';
import { InboxUserGridObject } from '@libs/types/src/inbox/object-type/inbox-user.object';
import { inboxUserAgendaDataFrag, inboxUserGridItemFrag } from './types/inbox-user.gql-types';
import { InboxUserAgendaDataUpdateInput } from '@libs/types/src/inbox/input-type/inbox-user-agenda-data-update.input';
import { InboxUserAgendaDataObject } from '@libs/types/src/inbox/object-type/inbox-user-agenda-data.object';

@Injectable({ providedIn: 'root' })
export class InboxUserGqlService extends GqlServiceV2 {
    async getInboxUsers(input: GridInput, frag: string = inboxUserGridItemFrag) {
        return this.query<InboxUserGridObject>(
            `
                query($input: GridInput!) {
                    inboxUser {
                        filter(input: $input) {
                            ${filterFrag}
                            items {
                                ${frag}
                            }
                        }
                    }
                }
            `,
            { input },
        );
    }

    async updateInboxUserAgendaDataForDataboxes(
        input: InboxUserAgendaDataUpdateInput,
        frag: string = inboxUserAgendaDataFrag,
    ): Promise<InboxUserAgendaDataObject> {
        return this.mutate<InboxUserAgendaDataObject>(
            `
                mutation($input: InboxUserAgendaDataUpdateInput!) {
                    inboxUser {
                        updateAgendaDataForDataboxes(input: $input) {
                            ${frag}
                        }
                    }
                }
            `,
            { input },
        );
    }

    async updateInboxUserAgendaDataForDms(
        input: InboxUserAgendaDataUpdateInput,
        frag: string = inboxUserAgendaDataFrag,
    ): Promise<InboxUserAgendaDataObject> {
        return this.mutate<InboxUserAgendaDataObject>(
            `
                mutation($input: InboxUserAgendaDataUpdateInput!) {
                    inboxUser {
                        updateAgendaDataForDms(input: $input) {
                            ${frag}
                        }
                    }
                }
            `,
            { input },
        );
    }

    async updateInboxUserAgendaDataForEmailClient(
        input: InboxUserAgendaDataUpdateInput,
        frag: string = inboxUserAgendaDataFrag,
    ): Promise<InboxUserAgendaDataObject> {
        return this.mutate<InboxUserAgendaDataObject>(
            `
                mutation($input: InboxUserAgendaDataUpdateInput!) {
                    inboxUser {
                        updateAgendaDataForEmailClient(input: $input) {
                            ${frag}
                        }
                    }
                }
            `,
            { input },
        );
    }
}
